import styles from './Paynow.module.scss';
import OverviewContext from 'store/overview-context';
import amountFormatter from 'utils/amountFormatter.js';
import { useContext, useEffect, useState } from 'react';
import images from 'assets/Images';
import Moneytech from '../Moneytech/Moneytech';
import Paytm from '../Paytm/Paytm';
import Jiopay from '../Jiopay/Jiopay';
import { Button, Checkbox, Popup, Textbox } from 'components/generic';
import { directDebitForm } from 'config/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons from '@fortawesome/free-solid-svg-icons';
import { requestValidator } from 'actions/actions';

const Paynow = props => {
	const [showPopup, setShowPopup] = useState(false);
	const [initPaytm, setPaytm] = useState(false);
	const [initJiopay, setJiopay] = useState(false);
	const overviewContext = useContext(OverviewContext);
	const [showtermsConditions, showTermsConditions] = useState(false);
	const [isDisabled, setisDisabled] = useState(true);

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	const gateways = overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.paymentGateways;

	const selectPayment = e => {
		overviewContext?.resetCreateObj();
		overviewContext.setpaymentMethod(e);
		e === 'c_razorpayCreds' && paymentInit(e);
		e === 'c_bankDetails' && setShowPopup(true);
		e === 'c_paytmCreds' && setPaytm(true);
		e === 'c_jiopayCreds' && setJiopay(true);
	};

	useEffect(() => {
		const termsAcceptance = overviewContext?.createObj?.acceptTerms;
		const isValid = requestValidator({ ...overviewContext?.createObj, validatorKey: 'directDebitForm' }) || !termsAcceptance;
		setisDisabled(isValid);
	}, [overviewContext?.createObj]);

	useEffect(() => {
		overviewContext?.setCreateObj(prevState => ({ ...prevState, 'ts_amount': overviewContext?.overviewData?.bd_dueAmt }));
	}, []);

	const paymentData = (
		<ul>
			{gateways?.map(el => (
				<li key={el} className={`${styles.paymentList} ${overviewContext?.paymentMethod === el && styles['is-active']}`} onClick={() => selectPayment(el)}>
					<img src={images[el]} alt='' />
				</li>
			))}
		</ul>
	);

	const paymentInit = e => {
		const obj = {
			...overviewContext?.createObj,
			bd_currencyCode: overviewContext?.overviewData?.bd_currencyCode,
			ts_paymentGateway: e,
			ts_paymentTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
		};
		overviewContext?.setCreateObj(obj);
		props.onPaymentInitiate(obj);
	};

	const handleAmount = (e, key) => {
		let amount = +e;
		Number.isNaN(amount) && (amount = 0);
		overviewContext?.setCreateObj(prevState => ({ ...prevState, [key]: amount }));
	};

	const handleValidation = (e, key) => {
		let amount = +e;
		Number.isNaN(amount) && (amount = 0);
		const maxAmt = overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.maximumAmount;
		const minAmt = overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.minimumAmount;
		amount > maxAmt && (amount = maxAmt);
		amount < minAmt && (amount = minAmt);
		overviewContext?.setCreateObj(prevState => ({ ...prevState, [key]: amount }));
	};

	const setData = (data, key) => {
		overviewContext?.setCreateObj(prevState => ({ ...prevState, [key]: data }));
	};

	const displayForm = directDebitForm?.map(el => (
		<div key={el?.key} className={styles.formRow}>
			<div className={`${styles['display-flex']} ${styles['align-center']}`}>
				<FontAwesomeIcon icon={icons[el?.icon]} size='xl' style={{ color: overviewContext?.overviewData?.defaultColor }} />
			</div>
			<div className={styles.formFields}>
				{el?.key === 'accountName' ? (
					<h5 style={{ lineHeight: '50px', paddingBottom: 0 }}>{overviewContext?.createObj?.customerInfo?.at()?.ci_customerNameUnformatted}</h5>
				) : (
					<Textbox
						infoContent={el?.placeholder ? 'Enter ' + el?.placeholder : ''}
						key={el?.key}
						whiteBg
						value={overviewContext?.createObj?.[el?.key]}
						mandatory
						onChange={e => setData(e?.target?.value, el?.key)}
						placeholder={el?.placeholder}
					/>
				)}
			</div>
		</div>
	));

	const termsCheck = (e, key) => {
		showTermsConditions(e);
		key && setData(true, 'acceptTerms');
	};

	return (
		<>
			<div className={styles.container}>
				{overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.allowEdit ? (
					<div className='row'>
						<div className='col-6'>
							<Textbox
								mandatory
								placeholder='e.g: 150'
								type='number'
								onChange={e => handleAmount(e?.target?.value, 'ts_amount')}
								onFocusOut={e => handleValidation(e?.target?.value, 'ts_amount')}
								value={overviewContext?.createObj?.ts_amount}
								label={getLang('AMOUNT_WISH_TO_PAY')}
								infoContent={getLang('INFO_AMOUNT_WISH_TO_PAY')}
							/>
						</div>
					</div>
				) : (
					<h3 className={styles.amount}>{amountFormatter({ value: overviewContext?.overviewData?.bd_dueAmt, currencyCode: overviewContext?.overviewData?.bd_currencyCode })}</h3>
				)}
				{overviewContext?.overviewData?.defaultGateway !== 'MONEYTECH' ? (
					<>
						{paymentData}
						<Moneytech showPopup={showPopup} onPopupToggle={setShowPopup} onMoneytechPaynow={() => paymentInit('c_bankDetails')} />
						{initPaytm && <Paytm />}
						{initJiopay && <Jiopay />}
					</>
				) : (
					<>
						{!showtermsConditions ? (
							<>
								<h1>{getLang('DIRECT_DEBIT')}</h1>
								<div className={styles.formContent}>{displayForm}</div>
								{overviewContext?.createObj?.bsbNumber && overviewContext?.createObj?.accountNumber && (
									<Checkbox
										content={getLang('I_AGREE')}
										link={getLang('TERMS_CONDITIONS')}
										checked={overviewContext?.createObj.acceptTerms}
										onLink={() => termsCheck(true, null)}
										onClick={e => setData(e?.target?.checked, 'acceptTerms')}
									/>
								)}

								{/* <Checkbox content='Does your bank support PayTo' checked={overviewContext?.createObj.enablePayTo} onClick={e => setData(e?.target?.checked, 'enablePayTo')} /> */}
								<Button primary full label={getLang('PAY_NOW')} disabled={isDisabled} onSubmit={() => paymentInit('c_bankDetails')} />
							</>
						) : (
							<>
								<Popup
									popupState={true}
									onClose={() => {
										showTermsConditions(false);
									}}
								>
									<div className={`scroll-bar ${styles.termsConditions}`} style={{ padding: '20px', height: 'calc(100vh - 200px)', overflow: 'scroll' }}>
										<h2>{getLang('TERMS_CONDITIONS')}</h2>
										<h4>
											<strong>{getLang('DETAILS_NOMINATED_AC')}</strong>
										</h4>
										<ul className={styles.termsForm}>
											{directDebitForm?.map(el => (
												<li key={el?.key} className={styles.termsForm__item}>
													<div className={styles.termsForm__tab}>
														<strong>{el?.label}</strong>
													</div>
													<div className={styles.termsForm__tab}>{overviewContext?.createObj?.[el?.key]}</div>
												</li>
											))}
										</ul>
										<div dangerouslySetInnerHTML={{ __html: `${overviewContext?.overviewData?.wf_linkConfiguration?.paynowConfiguration?.templateContent?.templateContent}` }}></div>
										<div style={{ paddingTop: '15px' }}>
											<Button primary full label={getLang('AGREE')} onSubmit={() => termsCheck(false, 'acceptTerms')} />
										</div>
									</div>
								</Popup>
							</>
						)}
					</>
				)}
			</div>
		</>
	);
};

export default Paynow;
